const apiType = {
    consumerApi: 'ConsumerApi',
    dataExtractApi: 'DataExtractApi',
    eposApi: 'EposApi',
};

export default apiType;
